/**
 * Asynchronously loads the component
 */

import { lazyLoad } from 'utils/loadable';

export const ConfiguratorPage = lazyLoad(
  () => import('./index'),
  module => module.ConfiguratorPage,
);
